export const SearchIcon = ({
  width = 24,
  height = 24,
  className,
  title = "Search",
  ...rest
}: IconProps) => {
  return (
    <svg
      data-testid="search-icon"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...rest}>
      <title>{title}</title>
      <path
        d="M11.2686 4C14.7306 4 17.537 6.81918 17.5371 10.2969C17.5371 12.1331 16.754 13.7853 15.5059 14.9365L18.8916 19.1875C19.0636 19.4035 19.0286 19.7186 18.8135 19.8916C18.5982 20.0646 18.2843 20.0295 18.1123 19.8135L14.7197 15.5537C13.7298 16.2111 12.544 16.5947 11.2686 16.5947L10.9463 16.5859C7.63402 16.4173 5 13.6661 5 10.2969C5.00015 6.81924 7.8066 4.0001 11.2686 4ZM11.2686 5C8.36315 5.0001 6.00015 7.36726 6 10.2969C6 13.2266 8.36306 15.5946 11.2686 15.5947C14.1741 15.5947 16.5371 13.2267 16.5371 10.2969C16.537 7.3672 14.174 5 11.2686 5Z"
        fill="currentColor"
      />
    </svg>
  );
};
